var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EA9F2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0005 25.999C20.1802 25.999 26.0005 20.1787 26.0005 12.999C26.0005 10.7621 25.4355 8.65717 24.4405 6.81909C22.1549 4.82157 19.1636 3.61133 15.8896 3.61133C8.70995 3.61133 2.88965 9.43163 2.88965 16.6113C2.88965 18.8482 3.45462 20.9532 4.44966 22.7913C6.73529 24.7888 9.72655 25.999 13.0005 25.999Z",
    fill: "#F5AB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.7957C18.3284 10.7957 19 10.1379 19 9.32654C19 8.51517 18.3284 7.85742 17.5 7.85742C16.6716 7.85742 16 8.51517 16 9.32654C16 10.1379 16.6716 10.7957 17.5 10.7957Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.7957C18.3284 10.7957 19 10.1379 19 9.32654C19 8.51517 18.3284 7.85742 17.5 7.85742C16.6716 7.85742 16 8.51517 16 9.32654C16 10.1379 16.6716 10.7957 17.5 10.7957Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.232 11.5678C17.812 11.6971 17.35 11.7206 16.87 11.6031C16.066 11.3974 15.412 10.7686 15.19 9.98115C15.082 9.59918 15.076 9.22308 15.142 8.88225C15.22 8.50615 14.95 8.15356 14.566 8.15356H10C8.2 8.15356 7 9.03504 7 11.0918V15.2053C7 17.2621 8.2 18.1436 10 18.1436H16C17.8 18.1436 19 17.2621 19 15.2053V12.1261C19 11.7382 18.616 11.4444 18.232 11.5678ZM15.112 12.6491L14.404 13.2015C14.008 13.5129 13.504 13.6657 13 13.6657C12.496 13.6657 11.986 13.5129 11.596 13.2015L9.718 11.7323C9.526 11.5795 9.496 11.2975 9.646 11.1094C9.802 10.9214 10.084 10.8861 10.276 11.0389L12.154 12.508C12.61 12.8665 13.384 12.8665 13.84 12.508L14.548 11.9556C14.74 11.8029 15.028 11.8322 15.178 12.0262C15.334 12.2142 15.304 12.4963 15.112 12.6491Z",
    fill: "#F4F4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitees);
export default __webpack_public_path__ + "static/media/invitees.c9334274bc9eaa618a99bd5267de6a96.svg";
export { ForwardRef as ReactComponent };